import ReactTable from 'react-table';
import React from 'react';
import PropTypes from 'prop-types';

// Local Deps
import './RecentSolicitations.scss';
import { columns } from './gridConfig';

export default class ProcurementHistoryGrid extends React.PureComponent {
  static propTypes = {
    RecentSolicitations: PropTypes.array.isRequired,    
  };
  
  render() {
    const { RecentSolicitations } = this.props;
    return (
      <div className="nf-drawings__grid">
        <ReactTable
          data={RecentSolicitations}
          columns={columns}
          defaultPageSize={RecentSolicitations.length}
          noDataText={RecentSolicitations.length ? 'No Data Found' : null}
          style={{ textAlign: 'center' }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/RecentSolicitations/RecentSolicitationsGrid.jsx